module.exports = __webpack_public_path__ + "a8cc5ab4bca8a8be7d4b338faed427a7.jpeg";